import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import getFormattedQuestionForAccordion from '../../../../../utils/get-formatted-question-for-accordion';
import type { SectionQuestionType } from '../../../types';

// @ts-expect-error - Automatic, Please fix when editing this file
const mapCommonQuestionsContent = ({ cmsSectionContent }): SectionQuestionType => {
  if (isEmpty(cmsSectionContent)) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return null;
  }

  return {
    isTwoColumn: false,
    items: getFormattedQuestionForAccordion(cmsSectionContent),
    type: CONTENT_SECTIONS.COMMON_QUESTIONS,
  };
};

export default mapCommonQuestionsContent;
